import React, { useState } from "react";
import ThreePhoneCommonMainAction from "./ThreePhoneCommonMainAction";
import TeeRating from "./TeeRating";
import Usp from "./Usp";
import ImageWithDesc from "./ImageWithDesc";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ContactForm from "../../components/Contact/ContactForm";
import ThankYou from "../Form/ThankYou";

const Contact = () => {
  const [thanku, setThanku] = useState(false);

  return (
    <>
      <section className=" bg-white">
        <div className="page-width">
          <ToastContainer />
          <div>
            <ImageWithDesc
              srcImg={
                require("../../assets/images/contact/contact-golf.svg").default
              }
              heading="CONTACT US BELOW"
              dataLayout={
                thanku ? (
                  <ThankYou setthanku={setThanku} />
                ) : (
                  <ContactForm setthanku={setThanku} toast={toast} />
                )
              }
            />
          </div>
        </div>
      </section>

      <ThreePhoneCommonMainAction
        heading={
          <span>
            REVOLUTIONARY <br /> GOLFING APP
          </span>
        }
        imgSrc={
          require("../../assets/images/pages/home/section_1/home_hero_section.svg")
            .default
        }
        show_subHeading={true}
      />
      
      <TeeRating />
      <Usp />
      
    
    </>
  );
};

export default Contact;
